<template>
  <GenericReport
    ref="report"
    class="clean-list"
    hide-header
    orientation="horizontal"
    :reportSpec="reportSpec"
    :adapterSpec="adapterSpec"
    :fetcher="fetchData"
    @rowClicked="showRowDetails"
  />
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import { toHex } from '@/utils'
import { go } from '@/models'

export default {
  tabTitle: 'Utilização',
  components: {
    GenericReport
  },
  props: {
    value: { required: true }
  },
  computed: {
    reportSpec() {
      return {
        code: 'wifiNetworkUsage',
        title: 'Utilização Recente da Rede Wifi'
      }
    },

    adapterSpec() {
      return {
        defaultSortable: false,
        defCodes: [],
        idProp: 'hbId',
        columns: [
          { t: 'Veículo', d: 'vehicleCode' },
          { t: 'Módulo', d: 'clientId' },
          { t: 'Firmware', d: 'fw', f: (x) => '0x' + toHex(x) },
          { t: 'Organização', d: 'orgCode' },
          {
            t: 'Data/hora|',
            d: 'timestamp',
            dataType: 'date',
            format: 'DD/MMM/YYYY HH:mm'
          },
          { t: 'Heartbeat', d: 'hbId' }
        ]
      }
    }
  },
  methods: {
    async fetchData() {
      const usage = await go.get(`/wifi/networks/${this.value.id}/usage`)
      return { count: usage.rows.length, rows: usage.rows.reverse() }
    },
    showRowDetails({ row }) {
      this.$router.push('/heartbeats/' + row.hbId)
    }
  }
}
</script>

<style></style>
